export default __webpack_public_path__ + "static/media/ireland.c8a1a099.svg";